import { useState } from "react";
import { camelizeKeys, snakifyKeys } from "../../../../util/helpers";
import { api, extractErrorMessage } from "../../../../util/api";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { Form } from "react-final-form";
import { AutoStatusParsingSettingForm } from "./AutoStatusParsingSettingForm";

export const EditAutoStatusParsingSettingModal = ({ setting, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (params) => {
    try {
      if (!params.automatedComment) {
        params.automatedComment = "";
      }
      const res = await api.put(`/admin/auto_status_parsing_settings/${params.id}`, snakifyKeys({ autoStatusParsingSetting: params }));

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Auto Status Parsing Setting</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={camelizeKeys({ ...setting })}>
            {(props) => <AutoStatusParsingSettingForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
